var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJunior(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.393,
    height: 39.199,
    viewBox: "0 0 33.393 39.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "report",
    transform: "translate(-80.869 -44.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14583",
    "data-name": "Path 14583",
    d: "M81.595,18381.719a.727.727,0,0,0-.726.727v37.748a.724.724,0,0,0,.726.725h31.941a.724.724,0,0,0,.726-.725v-7.26a.726.726,0,1,0-1.452,0v6.535H82.321v-36.3h22.893l7.6,8.977v14.979a.726.726,0,1,0,1.452,0v-15.244a.728.728,0,0,0-.174-.471l-7.985-9.436a.719.719,0,0,0-.552-.258Z",
    transform: "translate(0 -18336.793)",
    fill: "#0b2ff7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14584",
    "data-name": "Path 14584",
    d: "M378.1,18381.717a.725.725,0,0,0-.714.734v9.43a.725.725,0,0,0,.726.725h7.974a.726.726,0,1,0,0-1.451h-7.248v-8.7a.728.728,0,0,0-.738-.734Z",
    transform: "translate(-272.563 -18336.791)",
    fill: "#0b2ff7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14585",
    "data-name": "Path 14585",
    d: "M476.228,387.1a.726.726,0,1,1,.726.726A.726.726,0,0,1,476.228,387.1Z",
    transform: "translate(-363.418 -313.862)",
    fill: "#0b2ff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14586",
    "data-name": "Path 14586",
    d: "M167.069,18564.059a.729.729,0,0,0-.436.2l-7.428,6.758-2.416-2.715a.724.724,0,0,0-1.249.242.722.722,0,0,0,.163.719l2.907,3.268a.723.723,0,0,0,.5.24.731.731,0,0,0,.526-.186l7.971-7.254a.726.726,0,0,0-.542-1.268Zm-11.907-11.615a.726.726,0,1,0,0,1.451H163.5a.726.726,0,1,0,0-1.451Zm-3.993,0a.726.726,0,1,0,0,1.451H152.6a.726.726,0,1,0,0-1.451Zm-6.533,0a.726.726,0,1,0,0,1.451h3.972a.726.726,0,1,0,0-1.451Zm0,5.082a.726.726,0,1,0,0,1.451h11.232a.726.726,0,1,0,0-1.451Zm13.793,0a.726.726,0,1,0,0,1.451h2.883a.726.726,0,1,0,0-1.451Zm5.07,0a.726.726,0,1,0,0,1.451h.375a.726.726,0,1,0,0-1.451Zm-14.5,5.082a.726.726,0,1,0,0,1.451h5.433a.726.726,0,1,0,0-1.451Zm-3.993,0a.726.726,0,1,0,0,1.451h1.432a.726.726,0,1,0,0-1.451Zm0,5.08a.727.727,0,0,0,0,1.453h5.073a.727.727,0,0,0,0-1.453Zm7.632,0a.727.727,0,0,0,0,1.453h.372a.727.727,0,0,0,0-1.453Z",
    transform: "translate(-57.949 -18493.725)",
    fill: "#0b2ff7",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJunior);
export default __webpack_public_path__ + "static/media/junior.4242fecc9bc79902aebdc3b6bce6b5dc.svg";
export { ForwardRef as ReactComponent };